module.exports = __webpack_public_path__ + "static/media/winelist-cropped.9f3fb73b.jpg";